module.exports = __webpack_public_path__ + "img/left_bottom_0.6b15527.png";